(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-gallery')) {
    customElements.define(
      'video-gallery',
      class VideoGallery extends HTMLElement {
        connectedCallback() {
          this._onClick = this._onClick.bind(this);
          this._onSectionLoad = this._onSectionLoad.bind(this);
          this._onSectionUnload = this._onSectionUnload.bind(this);

          this._init();

          if (window.Shopify && window.Shopify.designMode) {
            this._onBlockSelect = this._onBlockSelect.bind(this);
            this._onBlockDeselect = this._onBlockDeselect.bind(this);
            this.addEventListener('shopify:block:select', this._onBlockSelect);
            this.addEventListener('shopify:block:deselect', this._onBlockDeselect);
            document.addEventListener('shopify:section:load', this._onSectionLoad);
            document.addEventListener('shopify:section:unload', this._onSectionUnload);
          }
        }

        disconnectedCallback() {
          this._teardown();
        }

        _init() {
          this.list = this.querySelector('.video-gallery__list');
          this.player = this.querySelector('.video-gallery__player');
          this.playerMedia = this.querySelector('[data-video-gallery-player-media]');
          this.playerTitle = this.querySelector('[data-video-gallery-player-title]');
          this.playerDescription = this.querySelector('[data-video-gallery-player-description]');
          this.activeCard = this.querySelector('.video-gallery__card.is-active');
          this._switching = false;
          this._loadingTimeout = null;

          this.spinner = document.createElement('span');
          this.spinner.className = 'video-gallery__player-spinner';
          this.spinner.setAttribute('aria-hidden', 'true');

          this._onMediaPlay = this._onMediaPlay.bind(this);
          this.addEventListener('click', this._onClick);
          this.addEventListener('media:play', this._onMediaPlay);

          if (this.activeCard) this._mount(this.activeCard, { autoplay: false });
        }

        _teardown() {
          this.removeEventListener('click', this._onClick);
          this.removeEventListener('media:play', this._onMediaPlay);
          clearTimeout(this._loadingTimeout);

          if (window.Shopify && window.Shopify.designMode) {
            this.removeEventListener('shopify:block:select', this._onBlockSelect);
            this.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
            document.removeEventListener('shopify:section:load', this._onSectionLoad);
            document.removeEventListener('shopify:section:unload', this._onSectionUnload);
          }
        }

        _onSectionLoad(event) {
          if (!event.target.contains(this)) return;
          this._init();
        }

        _onSectionUnload(event) {
          if (!event.target.contains(this)) return;
          this._teardown();
        }

        _onBlockSelect(event) {
          const card = event.target.closest('.video-gallery__card');
          if (!card || card === this.activeCard) return;
          this._select(card, { autoplay: false });
        }

        _onBlockDeselect(event) {
          const card = event.target.closest('.video-gallery__card');
          if (!card) return;
          this._pauseActive();
        }

        _onClick(event) {
          const button = event.target.closest('[data-video-gallery-select]');
          if (!button) return;

          const card = button.closest('.video-gallery__card');
          if (!card || card === this.activeCard || this._switching) return;

          this._select(card);
        }

        _select(card, { autoplay = true } = {}) {
          this._switching = true;

          this._pauseActive();

          if (this.activeCard) {
            this.activeCard.classList.remove('is-active');
            this.activeCard.removeAttribute('aria-current');
          }

          card.classList.add('is-active');
          card.setAttribute('aria-current', 'true');
          this.activeCard = card;

          if (this.player) this.player.classList.add('is-switching');
          this._mount(card, { autoplay });
          this._scrollIntoView(card);
          if (this.player) {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => this.player.classList.remove('is-switching'));
            });
          }

          this._switching = false;
        }

        _scrollIntoView(card) {
          if (!this.list) return;

          const listRect = this.list.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();

          const deltaX = cardRect.left < listRect.left
            ? cardRect.left - listRect.left
            : cardRect.right > listRect.right
              ? cardRect.right - listRect.right
              : 0;

          const deltaY = cardRect.top < listRect.top
            ? cardRect.top - listRect.top
            : cardRect.bottom > listRect.bottom
              ? cardRect.bottom - listRect.bottom
              : 0;

          if (deltaX === 0 && deltaY === 0) return;

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollBy({
            left: deltaX,
            top: deltaY,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        }

        _pauseActive() {
          if (!this.playerMedia) return;
          const media = this.playerMedia.querySelector('video-media');
          if (media && typeof media.pause === 'function') media.pause();
        }

        _onMediaPlay() {
          this._setLoading(false);
        }

        _setLoading(isLoading) {
          clearTimeout(this._loadingTimeout);
          this._loadingTimeout = null;

          if (this.player) this.player.classList.toggle('is-loading', isLoading);

          if (isLoading) {
            this._loadingTimeout = setTimeout(() => this._setLoading(false), 8000);
          }
        }

        _mount(card, { autoplay = true } = {}) {
          const mediaTemplate = card.querySelector('[data-video-gallery-player-template]');
          this._setLoading(false);

          if (this.playerMedia) {
            const aspectRatio = card.dataset.videoGalleryAspectRatio;
            if (aspectRatio) this.playerMedia.style.setProperty('--aspect-ratio', aspectRatio);

            this.playerMedia.textContent = '';
            this.playerMedia.appendChild(this.spinner);
            if (mediaTemplate) {
              this.playerMedia.appendChild(mediaTemplate.content.cloneNode(true));
              if (autoplay) {
                const media = this.playerMedia.querySelector('video-media');
                if (media && typeof media.play === 'function') {
                  this._setLoading(true);
                  media.play();
                }
              }
            }
          }

          const titleEl = card.querySelector('[data-video-gallery-card-title]');
          if (this.playerTitle) this.playerTitle.textContent = titleEl ? titleEl.textContent.trim() : '';

          const descriptionTemplate = card.querySelector('[data-video-gallery-player-description-template]');
          if (this.playerDescription) {
            this.playerDescription.textContent = '';
            if (descriptionTemplate) this.playerDescription.appendChild(descriptionTemplate.content.cloneNode(true));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
